var collectionVue = new Vue({
  el: '.collection.vue',
    data: {
        searchResultsLimit: 50,
        filters: {
            'colour': [],
            'size': [],
            'type': [],
            'shape': []
        },
        products: [],
        defaultProducts: [],
        sortValue: 'relevance',                
        section: '',
        defaultColours: [ 'Clears', 'Whites', 'Cool Neutrals', 'Greys', 'Silvers', 'Beiges', 'Warm Neutrals', 'Golds', 'Yellows', 'Oranges', 'Reds', 'Pinks', 'Purples', 'Blues', 'Aquas', 'Greens', 'Browns', 'Blacks', 'Fluorescents', 'Holographics' ],
        defaultSizes: [
            { 
              key: 'Microfine',
              value: 'Microfine - 0.1mm - 1/256" - 0.004"',
              range: true
            },
            { 
              key: 'Ultrafine',
              value: 'Ultrafine - 0.2mm - 1/128" - 0.008"',
              range: true
            },
            { 
              key: 'Fine',
              value: 'Fine - 0.4mm - 1/64" - 0.015"',
              range: true 
            },
            { 
              key: 'Chunky',
              value: 'Chunky - 0.6mm - 1/40" - 0.025"',
              range: true 
            },
            { 
              key: 'Extra Chunky',
              value: 'Extra Chunky - 1mm - 1/24" - 0.040"',
              range: true 
            },
            { 
              key: 'Super Chunky',
              value: 'Super Chunky - 3mm - 1/8" - 0.125"',
              range: true 
            },
            { 
              key: '2.5L / 84floz',
              value: '2.5L / 84floz',
              class: 'two-half-liter-84floz'
            },
            { 
              key: '1L / 34floz',
              value: '1L / 34floz',
              class: 'one-liter-34floz'
            },
            { 
              key: 'A5 Peel & Stick Sample',
              value: 'A5 Peel & Stick Sample',
              class: 'a5-peel-stick-sample'
            }
        ],
        isShopByColour: false,
        isFilterTypeTag: false,
        sections: [
            'Ready Mix Grout',
            'Ready Mixed Glitter Grout',
            'Blockers',                               
            'Glitter Shaker',                    
            'Glitter Shaker Mixed',
            'Multi Size Glitter Shaker',                      
            'Ultra Sparkle Glitter',
            'Ultra Sparkle Glitter Multi',
            'Mixed Ultra Sparkle Glitter',
            'Shaped Ultra Sparkle Glitter',
            'Craft Glitter',
            'Craft Glitter Multi',
            'Shaped Craft Glitter',
            'Polyurethane & Epoxy Glitter',
            'Mixed Polyurethane & Epoxy Glitter',
            'Craft Glitter Shaker',
            'Mega Craft Shaker',
            'Eco Friendly Glitter',
            'Bio Ultra Sparkle Glitter',
            'Eco Craft Glitter',                                            
            'Glitter Paint Additive',
            'Glitter Grout Additive',
            'Auto Flake',
            'Glitter Box Sets',
            'Interior Paint',
            'Exterior Paint',
            'Chalk Paint',
            'Chalk Based Furniture Paint',
            'Clear Lacquers',
            'Bamboo Painting Kits',
            'Bamboo Paint Roller Frames',
            'Paint Roller Sleeves',
            'Bio Paint Roller Trays',
            'Painters Tapes',
            'Recyclable Dust Sheets',
            'Bamboo Paint Stirrers',
            'Beeswax Polish',          
            'Bamboo Paint Brushes',
            'Chalk & Wax Paint Brushes',
            'Buffing Pads',
            'Kitchen & Bathroom Sealant',
            'Construction Sealant',
            'Glitter Sealant',                      
            'Powder Pigment',
            'Natural Dye',                  
            'Grout Dye',                      
            'Epoxy Dye',
            'Cement Dye',
            'Mica Dye',
            'Automotive Powder Pigment'
        ],
        sectionsSpecialOrders: [
          {
              filter: 'Multi Purpose Glitter',
              sections: [
                  'Ultra Sparkle Glitter'
              ]
          }
        ],
        shopByTypeItems: [
            'Glitter Shakers',
            'Multi Purpose Glitter',
            'Multi Purpose Glitters',
            'Craft Glitters',
            'Crafting Glitters',
            'Epoxy Glitters',          
            'Eco Friendly Glitters',
            'Paint Glitters',
            'Grout Glitters',          
            'Automotive Glitters',
            'Glitter Box Sets',
            'Buffing Pads',
            'Interior Acrylic Paints',
            'Exterior Acrylic Paints',
            'Chalk Paints',
            'Furniture Paints',
            'Blockers',
            'Bamboo Painting Kits',
            'Bamboo Paint Roller Frames',
            'Paint Roller Sleeves',
            'Bio Paint Roller Trays',
            'Paint Brushes',
            'Painters Tapes',
            'Recyclable Dust Sheets',
            'Bamboo Paint Stirrers',
            'Clear Lacquers',
            'Beeswax Polish',
            'Ready Mixed Grouts',
            'Ready Mixed Glitter Grouts',
            'Multi Purpose Powders',
            'DIY Powders',
            'Cosmetic Powders',
            'Automotive Powders',
            'Kitchen Sealants',
            'Bathroom Sealants',
            'Construction Sealants',
            'Glitter Sealants'
        ],
        reviews: {},
        toLoadProducts: false,
        currentProductsPage: 1,
        totalPages: 0,
        fetchingReviews: []
    },
    mounted() {
        const _this = this;
        if ( ! window.products ) { return; }
        $( '.collection.main.default' ).remove();
        $( '.collection.vue' ).removeClass( 'hidden' );
        this.defaultProducts = window.products;
        this.products = JSON.parse( JSON.stringify( this.defaultProducts ) );
        $(document).on( 'change', '.sort', function() {
            _this.products = _this.sortProducts( _this.products, $(this).val() );
            const $mirror = $( '.sort-mirror' );
            $mirror.text( $( 'option:selected', this ).text() );
            let width = $mirror.outerWidth() + 83;
            $(this).css({'width': width + 'px'});
        });
        // $(document).on( 'click', '.filters.two .term', function() {
        //     _this.setFilterSelection( $( '.text', this ).text(), $(this).closest( '.attribute' ).data( 'key' ) );
        // });
        $( '.shop.collection .filters .content .links .content ul.three li.one' ).click(function() {
            for ( let key in _this.filterKeys ) {
                const term = _this.filterKeys[key];
                // $( '.filters.two:not(.theme) .attribute.' + key + ' .title .two' ).text( term.title );
            }            
        });
        const totalResults = window.totalResults;          
        if ( totalResults > this.searchResultsLimit ) {
            let div = totalResults / this.searchResultsLimit;
            let totalPages = div % 1 > 0 ? ( parseInt( div ) + 1 ) : div;
            this.toLoadProducts = true;
            this.totalPages = totalPages;
            this.currentProductsPage += 1;
        } else {
            this.parseReviews();
        }
    },
    watch: {
        currentProductsPage( val, oldval ) {
            if ( val == this.totalPages ) {
                this.parseReviews();
            }
        },
        toLoadProducts( val, oldval ) {
            const _this = this;
            if ( ! val ) {
                return false;
            }
            this.toLoadProducts = false;
            fetch('https://www.hemway.com/search.api?type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last&q=' + window.searchTerms + '&page=' + this.currentProductsPage)
            .then((response) => response.json())
            .then((data) => {
                data.searchResults.forEach((item, i) => {
                    var title_tags = item.tags.filter(tag => tag.includes( 'Title_' ));
                    if ( title_tags.length ) {
                        item.title = title_tags[0].replace( 'Title_', '' );
                    }
                });
                let products = JSON.parse( JSON.stringify( _this.defaultProducts ) ).concat( data.searchResults );
                _this.$set( _this, 'defaultProducts', products );
                _this.$set( _this, 'products', JSON.parse( JSON.stringify( _this.defaultProducts ) ) );      
                setTimeout(() => {
                    _this.filterProducts();
                    if ( this.currentProductsPage < this.totalPages ) {
                        this.currentProductsPage += 1;
                        this.toLoadProducts = true;
                    } else {
                        _this.toLoadProducts = false;
                    }
                }, 1);
            });
        }
    },
    computed: {
        utils() {
            return Utils ? Utils : {};
        },
        showFilterSizes() {
            return window.totalResults < 125;
        },
        filterKeys() {
            let filters = {
              'colour': {
                  'title': 'Colour',
                  'items': []
              },
              'size': {
                  'title': 'Size',
                  'items': []
              },
              'type': {
                  'title': 'Type',
                  'items': []
              },
              'shape': {
                  'title': 'Shape',
                  'items': []
              }              
            };
            let colours = [];                      
            this.defaultProducts.forEach((product) => {
                const tags = product.tags.filter(tag => tag.includes( 'Tone_' ) );
                tags.forEach(tag => {
                    const colour = tag.replace( 'Tone_', '' );                        
                    if ( ! colours.includes( colour ) ) {
                        colours.push(colour);
                    }
                });
            });
            this.defaultColours.forEach(colour => {
                if ( colours.findIndex( item => item == colour ) > -1 ) {
                    filters[ 'colour' ].items.push( colour );
                }
            }); 
            if ( this.showFilterSizes ) {                  
                let sizes     = [];
                let size_tags = [];
                this.defaultProducts.forEach((product) => {
                    let proceed = true;
                    for (let i = 0; i < product.tags.length; i++) {
                        let tag = product.tags[i];
                        if ( tag.includes( 'Size_' ) && ! size_tags.includes( tag ) ) {
                            size_tags.push( tag );
                            proceed = false;
                        }
                    }
                    if ( proceed ) {
                        product.variants.forEach(variant => {
                            if ( variant.options.length > 1 && ! sizes.includes( variant.options[1] ) ) {
                                sizes.push( variant.options[1] );
                            }
                        });
                    }
                });    
                sizes = this.defaultSizes.filter(size => sizes.findIndex(item => item.includes( size.key) ) !== -1);                      
                let new_sizes = [];
                size_tags.forEach(tag => {
                    tag = tag.replace( 'Size_', '' );
                    if ( sizes.findIndex(size => size.key.includes(tag)) == -1 ) {
                        new_sizes.push({
                            key: tag,
                            range: false,
                            value: tag
                        });
                    }
                });
                filters[ 'size' ].items = sizes.concat( new_sizes );                  
            }
            let types = Object.keys( this.groupedProducts.default );
            this.defaultProducts.filter((product) => {
                for (i = 0; i < product.tags.length; i++) {
                    if ( product.tags[i].includes( 'Type_' ) ) {
                        return true;
                    }
                }
                return false;
            }).forEach((product) => {
                const key = product.tags.filter((tag) => tag.includes( 'Type_' ))[0].split( 'Type_' )[1];
                if ( ! types.includes( key ) ) {
                    types.push( key );
                }
            });
            let types2 = [];
            this.shopByTypeItems.forEach(section => {
                if ( types.includes( section )  ) {
                    types2.push( section );
                }
            });
            filters[ 'type' ].items = types2;
            return filters;
        }, 
        groupedProducts() {
            let items = {
                'default': {},
                'featured': {}
            };
            const _this = this;
            let products = JSON.parse( JSON.stringify( this.products ) );
            const sectioned_products = products.filter((product) => {
                for (i = 0; i < product.tags.length; i++) {
                    if ( product.tags[i].includes( 'Collection_' ) && product.tags[i] !== 'Collection_Featured' ) {
                        return true;
                    }
                }
                return false;
            });
            products.filter(product => ! sectioned_products.includes( product ))
            .forEach(product => {
                if ( product.title in items.default ) {
                    items.default[ product.title ].items.push( product );
                } else {
                    items.default[ product.title ] = {
                        'items': [ product ],
                        'colours': true
                    };
                }
            });
            sectioned_products.forEach((product) => {
                const key = product.tags.filter((tag) => tag.includes( 'Collection_' ) && tag !== 'Collection_Featured')[0].split( 'Collection_' )[1];
                if ( key in items.default ) {
                    items.default[key].items.push( product );
                } else {
                    items.default[key] = {
                        'items': [ product ],
                        'colours': false,
                        'mixed': true
                    };
                }
            });
            let results = {
                default: {},
                featured: {}
            };
            for ( let type in items ) {
                this.sections.forEach(section => {
                    if ( section in items[type] ) {
                        results[type][section] = items[type][section];
                    }
                });
              
                for ( let section in items[type] ) {
                    if ( ! ( section in results[type] ) ) {
                        results[type][section] = items[type][section];
                    }
                }
            }
            for ( let type in results ) {
                for ( let section in results[type] ) {
                    results[type][section].items.forEach((product, i) => {
                        if ( product.variants.length > 1 ) {
                            product.variants.sort((a,b) => a.id - b.id);
                        }
                    }); 
                }             
            }
            if ( this.filters.type.length ) {
                for ( let i = 0; i < this.sectionsSpecialOrders.length; i++ ) {
                    const item = this.sectionsSpecialOrders[i];
                    if ( _this.filters.type.includes( item.filter ) ) {
                        let _results = {
                            default: {},
                            featured: {}
                        };
                        for ( let type in results ) {
                            item.sections.forEach(section => {
                                if ( section in results[type] ) {
                                    _results[type][section] = results[type][section];
                                }
                            });
                            for ( let section in results[type] ) {
                                if ( ! ( section in _results[type] ) ) {
                                    _results[type][section] = results[type][section];
                                }
                            }
                        }
                        results = _results;
                        break;
                    }    
                }
            }
            if ( 'relevance' == this.sortValue ) {
                return results;
            }
            if ( [ 'price-low', 'price-high' ].includes( this.sortValue ) ) {
                for ( let type in results ) {
                    let sortedCategories = null;
                    if ( 'price-low' == this.sortValue ) {
                        sortedCategories = Object.entries(results[type]).sort((a, b) => {
                            const minPriceA = Math.min(...a[1].items.map(item => parseFloat(item.price.raw)));
                            const minPriceB = Math.min(...b[1].items.map(item => parseFloat(item.price.raw)));
                            return minPriceA - minPriceB;
                        });
                    } else {
                        sortedCategories = Object.entries(results[type]).sort((a, b) => {
                            const minPriceA = Math.max(...a[1].items.map(item => parseFloat(item.price.raw)));
                            const minPriceB = Math.max(...b[1].items.map(item => parseFloat(item.price.raw)));
                            return minPriceB - minPriceA;
                        });
                    }
                    results[type] = Object.fromEntries( sortedCategories );
                }
            } else if ( [ 'popular', 'newest' ].includes( this.sortValue ) ) {
                const keyword = 'Highlight_' + ( 'newest' == this.sortValue ? 'New In' : ( this.sortValue.charAt(0).toUpperCase() + this.sortValue.slice(1) ) );
                for ( let type in results ) {
                    let items = {};
                    for (let key in results[type]) {
                        let category = results[type][key];
                        if ( category.items.findIndex(item => item.tags.includes(keyword)) > -1 ) {
                            items[key] = category;
                        }
                    }
                    for (let key in results[type]) {
                        let category = results[type][key];
                        if ( ! ( key in items ) ) {
                            items[key] = category;
                        }
                    }
                    results[type] = items;
                }
            }
            return results;
        },
        availableSizes() {
            return this.filterKeys.size.items;
        },
        hasActivefilters() {
            for ( let key in this.filters ) {
                if ( this.filters[key].length ) {
                    return true;
                }
            }
            return false;
        },
        activeFilters() {
            const _this = this;
            let filters = JSON.parse( JSON.stringify( this.filters ) );
            if ( filters.size.length ) {
                filters.size = this.filterKeys.size.items.filter(item => filters.size.findIndex(size => size == item.key) !== -1);
            }
            return filters;
        },
        hasFilterKeys() {
            for ( let key in this.filterKeys ) {
                if ( this.filterKeys[key].items.length ) {
                    return true;
                }
            }
            return false;
        },
        summary() {
            if ( ! window.showReviews ) {
                return {};
            }
            return Object.keys(this.reviews || {}).length ? Object.values(this.reviews)[0] : {};
        },
        hasGroupReview() {
            return group => {
                const summary = this.getGroupReviewSummary(group);
                return summary && Object.keys(summary).length > 0 && parseFloat(summary.average) > 4;
            };
        }      
    },
    methods: {
        getFilterClass(term, type) {
            if ( 'size' == type ) {
                let filters = this.filterKeys.size.items;
                const index = filters.findIndex(item => item.key == term);
                if ( index >= 0 ) {
                    term = 'class' in filters[index] ? filters[index].class : filters[index].key;  
                }                      
            }
            return this.utils.htmlEntities( term.toLowerCase().replace(/[\/\s&]+/g, '-') );
        },
        setFilterSelection(term, type) {
            this.filters[type].includes(term) ? this.filters[type] = this.filters[type].filter(item => item !== term) : this.filters[type].push(term);
            // $(document).find( '.filters.two .attribute.' + type + ' .term.' + this.getFilterClass( term, type ) ).toggleClass( 'active' );
            this.filterProducts();
        },
        filterProducts() {
            const _this = this;
            let products = JSON.parse( JSON.stringify( this.defaultProducts ) ); 
            if ( this.filters.type.length ) {
                let filters = this.filters.type;
                products = products.filter((product) => {
                    for (i = 0; i < filters.length; i++) {
                        if ( product.tags.includes( 'Type_' + filters[i] ) ) {
                            return true;
                        }
                    }
                    return false;
                });
                if ( products.length ) {
                    this.isFilterTypeTag = true;
                } else {
                    products = JSON.parse( JSON.stringify( this.defaultProducts ) );
                }
            }
            if ( this.filters.size.length ) {
                let filters = this.filters.size;  
                let tmp_products = products.filter((product) => {
                    for (i = 0; i < filters.length; i++) {
                        let size = _this.filterKeys.size.items.filter(item => item.key == filters[i])[0].key;
                        if ( product.tags.includes( 'Size_' + size ) ) {
                            product.size = size;
                            return true;
                        }
                    }
                    return false;
                });
                products.forEach((product) => {
                    if ( ! tmp_products.includes( product ) ) {                                
                        for(let i = 0; i < filters.length; i++) {
                            let size_index = _this.filterKeys.size.items.findIndex(item => item.key == filters[i]);
                            const size = _this.filterKeys.size.items[size_index].key;
                            const index = product.variants.findIndex(variant => variant.options.length > 1 && variant.options[1].includes( size ));
                            if ( index !== -1 ) {
                              let _product = JSON.parse( JSON.stringify( product ) );
                              let variant = _product.variants[ index ];
                              if ( ! ( 'hover_image' in variant ) && 'hover_image' in _product.variants[0] ) {
                                  variant.hover_image = _product.variants[0].hover_image;
                              }
                              _product.id = variant.id;
                              _product.price = variant.price;
                              _product.url = _product.url + '?variant=' + variant.id;
                              _product.size = _this.filterKeys.size.items[size_index].key;
                              _product.variants = [ variant ];
                              tmp_products.push( _product );
                            }
                        }
                    }
                }); 
                products = tmp_products;
            }
            let filters = this.filters.colour;
            if ( filters.length ) {
                products = products.filter(product => {
                    let found = false;
                    for(let i = 0; i < filters.length; i++) {
                        if ( product.tags.findIndex(tag => tag.includes( filters[i] )) > -1 ) {
                          found = true;
                          break;
                        }
                    }
                    return found;
                });  
            }
            let shapedProducts = [];
            let otherProducts = [];
            products.forEach(product => {
                if ( this.isShapedCollection(product) ) {
                    product.variants.forEach(variant => {
                        let _product = JSON.parse(JSON.stringify(product));
                        _product.id = variant.id;
                        _product.price = variant.price;
                        _product.url = _product.url + '?variant=' + variant.id;
                        _product.variants = [ variant ];
                        shapedProducts.push(_product);
                    });
                } else {
                    otherProducts.push(product);
                }
            });
            products = shapedProducts.concat(otherProducts);
            this.products = this.sortProducts( products, this.sortValue );
        },
        sortProducts( products, order ) {
            switch(order) {
              case 'relevance':
                products = JSON.parse( JSON.stringify( this.defaultProductSort( products ) ) );
                break;
              case 'price-low':
                products.sort((a,b) => parseFloat( a.price.raw ) - parseFloat( b.price.raw ));
                break;
              case 'price-high':
                products.sort((a,b) => parseFloat( b.price.raw ) - parseFloat( a.price.raw ));
                break;
              default:
                let keyword = 'Highlight_' + ( 'newest' ? 'New In' : order.charAt(0).toUpperCase() + order.slice(1) );
                products.sort(function(a, b) {                          
                    let hasNewInA = a.tags.includes( keyword );
                    let hasNewInB = b.tags.includes( keyword );                          
                    if ( hasNewInA && ! hasNewInB ) {
                      return -1;
                    } else if (! hasNewInA && hasNewInB ) {
                      return 1;
                    } else {
                      return 0;
                    }
                });
                break;
            }
            return products;
        },
        getColourCount( product ) {                
            return parseInt( product.colour_count );
        },
        renderColourCount( product ) {
            const total = this.getColourCount( product );
            return total + ' ' + ( product.product_type.includes( 'Shaped' ) ? 'Shape' : 'Colour' ) + ( total == 1 ? '' : 's' );
        },
        hasColours( product ) {
            const keywords = [ 'Glitter Tube Craft Box', 'Glitter Tube Mixed Polyurethane Box', 'Glitter Tube Mixed Ultra Sparkle Box', 'Glitter Tube Polyurethane Box', 'Glitter Tube Ultra Sparkle Box', 'Oval Wax Brush Set', 'Oval Wax Brush Set 2', 'Oval Wax Brush Set 3', 'Rounded Head Brush Set', 'Sculpted Brush Set', 'Matte Lacquer', 'Satin Lacquer' ];
            return this.getColourCount( product ) || ! keywords.includes( product.product_type );
        },
        getProductColour( product ) {
            let variant = product.variants[0]; // variant-specific display
            let text    = '';
            if ( product.options.includes( 'Grout Colour' ) || product.options.includes( 'Glitter Colour' ) ) {
                if ( product.options.includes( 'Grout Colour' ) && product.options.includes( 'Glitter Colour' ) ) {
                    let groutIndex   = product.options.indexOf( 'Grout Colour' );
                    let glitterIndex = product.options.indexOf( 'Glitter Colour' );
                    let groutColour  = variant.options[ groutIndex ] || '';
                    let glitterColour = variant.options[ glitterIndex ] || '';
                    text = groutColour && glitterColour ? groutColour + ' & ' + glitterColour : groutColour || glitterColour;
                } else {
                    let key  = product.options.includes( 'Grout Colour' ) ? 'Grout Colour' : 'Glitter Colour';
                    let index = product.options.indexOf( key );
                    text = variant.options[ index ] || '';
                }
            } else if ( product.options.includes( 'Colour' ) ) {
                let index = product.options.indexOf( 'Colour' );
                text = variant.options[ index ] || '';
            }
            if ( 'size' in product ) {
                text += ' / ' + product.size;
            }
            return text;
        },
        getHighlights( product ) {
            let items = [];
            let tags = product.tags.filter(tag => tag.includes( 'Highlight' ));
            tags.forEach(tag => {
                items.push( tag.replace( 'Highlight_', '' ) );
            });
            return items;
        },
        shopByFilter(term, type) {  
            const _this = this;
            this.setFilterSelection(term, type);
            if ( this.filters[type].includes(term) ) {
                let anchor = 'collection';
                if ( $(window).width() <= 1350 ) {
                    switch (type) {
                        case 'type':
                            if ( this.filterKeys.colour.items.length ) {
                                anchor = 'colour';
                            } else if ( this.filterKeys.size.items.length ) {
                                anchor = 'size';
                            }
                          break;      
                        case 'colour':
                          if ( this.filterKeys.size.items.length ) {
                              anchor = 'size';
                          }
                          break;
                    }
                }
                setTimeout(() => {                              
                    $( 'html, body' ).animate({
                        scrollTop: $( '[name="' + anchor + '"]' ).offset().top - ( $(window).width() >= 1350 ? 82 : 0 )
                    }, 1375);
                }, 75);
            }
            this.parseReviews();
        },
        resetFilters(type = null) {
            if ( type ) {
                this.filters[type] = [];
                // $( '.filters.two .attribute.' + type + ' .term.active' ).removeClass( 'active' );
                if ( 'size' == type ) {
                    let products = JSON.parse( JSON.stringify( this.products ) );
                    products.forEach(product => {
                        delete product.size;
                    });
                    this.products = products;
                }
            } else {
                this.filters = {
                    'colour': [],
                    'size': [],
                    'type': []
                };
                this.products = JSON.parse( JSON.stringify( this.defaultProducts ) );
                // $( '.filters.two .term.active' ).removeClass( 'active' ); 
            }
        },
        defaultProductSort( products ) {                  
            let results = [];
            this.defaultProducts.forEach(product => {
                let items = products.filter( item => item.product_id == product.id );
                results = results.concat( items );
            });
            return results;
        },
        getFeaturedImage( product ) {
            if ( ! product.variants.length ) {
                return '';
            }
            if ( product.variants[0].background_image ) {
                return product.variants[0].background_image;
            } else if ( product.variants.length > 3 ) {
                return product.variants[3].image;
            } else {
                return product.variants[0].image;
            }                   
        },
        async getReviews( productType ) {
            const _this = this;
            const productId = encodeURIComponent(productType);
            const url = `https://alt.hemway.com/api/index.php/review/summary?productId=${productId}`;
            
            const payload = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            };

            this.fetchingReviews.push( productType );

            let ratings = await fetch( url, payload )
                .then( response => response.json() )
                .catch( error => {
                    console.error( 'Error:', error );
                    return [];
                }).finally(() => {
                    _this.fetchingReviews = _this.fetchingReviews.filter( item => item !== productType );
                });
          
            return ratings;
        },
        parseReviews() {
            const _this = this;
            let key = Object.keys( this.groupedProducts.featured ).length ? 'featured' : 'default';
            let first_section = Object.keys(this.groupedProducts[key])[0];
            const product = this.groupedProducts[key][ first_section ].items[0];
            let productType = product.product_type;
            // const reviewTag = product.tags.find(tag => tag.startsWith('Reviews_'));
            // let productType = reviewTag ? reviewTag.replace('Reviews_', '') : product.product_type;
            // console.log( 'productType:', productType, 'key:', key, 'first_section:', first_section, 'reviewTag:', reviewTag );
            if ( 'mixed' in _this.groupedProducts[key][ first_section ] ) {
                _this.groupedProducts[key][ first_section ].items.forEach(product => {
                    productType = product.product_type;
                    if ( ! ( productType in _this.reviews ) ) {    
                        _this.getReviewsByType( productType );
                    }
                });

                Object.keys(_this.groupedProducts[key]).forEach(section => {
                    if ( first_section != section ) {                                
                        if ( 'mixed' in _this.groupedProducts[key][ section ] ) {
                            _this.groupedProducts[key][ section ].items.forEach(product => {      
                                productType = product.product_type;
                                if ( ! ( productType in _this.reviews ) ) {    
                                    _this.getReviewsByType( productType );
                                }
                            });
                        } else {
                            productType = _this.groupedProducts[key][ section ].items[0].product_type;
                            if ( ! ( productType in _this.reviews ) ) {                     
                                _this.getReviewsByType( productType );
                            }
                        }
                    }
                });
              
                if ( 'featured' == key ) {
                    key = 'default';
                    Object.keys(_this.groupedProducts[key]).forEach(section => {
                        if ( 'mixed' in _this.groupedProducts[key][ section ] ) {
                            _this.groupedProducts[key][ section ].items.forEach(product => {      
                                productType = product.product_type;
                                if ( ! ( productType in _this.reviews ) ) {    
                                    _this.getReviewsByType( productType );
                                }
                            });
                        } else {
                            productType = _this.groupedProducts[key][section].items[0].product_type;
                            if ( ! ( productType in _this.reviews ) ) {                     
                                _this.getReviewsByType( productType );
                            }
                        }
                    });
                }
                
            } else {
                if ( ! ( productType in _this.reviews ) ) {  
                   Promise.resolve( this.getReviews( productType ) )
                    .then((results) => {
                        _this.$set( _this.reviews, productType, results );
                    }).then(() => {                        
                        Object.keys(_this.groupedProducts[key]).forEach(section => {
                            if ( first_section != section ) {
                                if ( 'mixed' in _this.groupedProducts[key][ section ] ) {
                                    _this.groupedProducts[key][ section ].items.forEach(product => {      
                                        productType = product.product_type;
                                        if ( ! ( productType in _this.reviews ) ) {    
                                            _this.getReviewsByType( productType );
                                        }
                                    });
                                } else {
                                    productType = _this.groupedProducts[key][section].items[0].product_type;
                                    if ( ! ( productType in _this.reviews ) ) {                     
                                        _this.getReviewsByType( productType );
                                    }
                                }
                            }
                        });
                        if ( 'featured' == key ) {
                            key = 'default';
                            Object.keys(_this.groupedProducts[key]).forEach(section => {
                                if ( 'mixed' in _this.groupedProducts[key][ section ] ) {
                                    _this.groupedProducts[key][ section ].items.forEach(product => {      
                                        productType = product.product_type;
                                        if ( ! ( productType in _this.reviews ) ) {    
                                            _this.getReviewsByType( productType );
                                        }
                                    });
                                } else {
                                    productType = _this.groupedProducts[key][section].items[0].product_type;
                                    if ( ! ( productType in _this.reviews ) ) {                     
                                        _this.getReviewsByType( productType );
                                    }
                                }
                            });
                        }
                    })
                    .catch( error => {
                        console.error( 'Error:', error );
                    });   
                }
            }
        },
        getReviewsByType( productType ) {
            const _this = this;
            const product   = this.products.find(item => item.product_type == productType);
            const reviewTag = product.tags.find(tag => tag.startsWith('Reviews_'));
            const productId = reviewTag ? reviewTag.replace('Reviews_', '') : productType;
            if ( productId in _this.reviews ) {
                return;
            }
            if ( _this.fetchingReviews.includes( productId ) ) {
                return;
            }
            Promise.resolve( this.getReviews( productId ) )
            .then((results) => {
                _this.$set( _this.reviews, productId, results );  
            })
            .catch( error => {
                console.error( 'Error:', error );
            });
        },
        getGroupReviewSummary(group, product = null) {
            product = ( product && ( 'mixed' in group ) ) ? product : group.items[0];
            const reviewTag = product.tags.find(tag => tag.startsWith('Reviews_'));
            const product_type = reviewTag ? reviewTag.replace('Reviews_', '') : product.product_type;
            return this.reviews[ product_type ] || {};
        },
        getFeaturedImageAltText( product ) {
            let text = '';
            if ( product.variants.length ) {                      
                if ( product.variants[0].background_image ) {
                    text = product.variants[0].background_image_alt_text;
                } else if ( product.variants.length > 3 ) {
                    text = product.variants[3].image_alt_text;
                } else {
                    text = product.variants[0].image_alt_text;
                }
            }
            if ( ! text ) {
                text = product.title;
            }
            return text;
        },
        getHoverImageAltText( product ) {
            let text = '';
            if ( product.variants[0].hover_image ) {
                text = product.variants[0].hover_image_alt_text;
            }
            if ( ! text ) {
                text = this.getFeaturedImageAltText( product );
            }
            return text;
        },
        isShapedCollection( product ) {
            const shapedTags = [
                'Collection_Shaped Ultra Sparkle Glitter',
                'Collection_Shaped Craft Glitter'
            ];
            return product.tags.some( tag => shapedTags.includes( tag ) );
        }      
    }
});